import React from 'react';
import { Box, Typography } from '@mui/material';
import YouTube from '@mui/icons-material/YouTube';
import { feedPath } from '../../pages/feed/feedPresentation';

export function feedBannerPath(banner) {
  const config = banner.appConfig;
  return config?.feedPostId ? feedPath({ id: config.feedPostId, slug: config.feedSlug }) : null;
}

export function visibleWebBanners(items = []) {
  return items.filter(
    (banner) =>
      !banner.appConfig?.appOnly &&
      (!banner.appConfig?.feedPostId || banner.appConfig.enabled !== false),
  );
}

// The uploaded app image already contains the editor's crop. Do not crop/zoom it again.
// Keep the legacy web banner dimensions; isolate feed artwork from the text column.
export default function FeedBannerContent({ banner }) {
  const config = banner.appConfig;
  const darkText = config.contentTone === 'dark';
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        bgcolor: darkText ? '#f5f5f5' : '#171717',
        color: darkText ? '#171717' : '#fff',
        position: 'relative',
      }}
    >
      <Box
        component="img"
        src={config.imageUrl || banner.imageUrl}
        alt=""
        sx={{
          width: { xs: '36%', md: '40%' },
          height: '100%',
          objectFit: 'contain',
          display: 'block',
          flexShrink: 0,
        }}
      />
      <Box sx={{ minWidth: 0, flex: 1, px: { xs: 1.5, md: 5 }, alignSelf: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
          {config.sourceIcon === 'youtube' && (
            <YouTube sx={{ color: '#ff0033', fontSize: { xs: 20, md: 28 } }} />
          )}
          <Typography
            noWrap
            sx={{
              fontWeight: 700,
              fontSize: { xs: 16, md: 24 },
              lineHeight: 1.4,
              color: darkText ? '#171717' : '#fff',
            }}
          >
            {config.headline || banner.title}
          </Typography>
        </Box>
        {config.subtitle && (
          <Typography
            sx={{
              fontSize: { xs: 12, md: 16 },
              lineHeight: 1.45,
              mt: 0.5,
              color: darkText ? 'rgba(0,0,0,.7)' : 'rgba(255,255,255,.8)',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {config.subtitle}
          </Typography>
        )}
      </Box>
      {config.showAd && (
        <Typography
          sx={{
            position: 'absolute',
            top: 4,
            left: 6,
            fontSize: 10,
            px: 0.5,
            bgcolor: 'rgba(0,0,0,.6)',
            color: '#fff',
          }}
        >
          AD
        </Typography>
      )}
    </Box>
  );
}
